import { createSelector } from '@ngrx/store';

import { getBuyerState } from '../feature-selector';
import { BuyerState } from '../state';
import { CategoryState } from './category.state';
import { Category } from '~app/modules/generic/models';

const getCategoryState = createSelector(
  getBuyerState,
  (state: BuyerState) => {
    return state.category;
  }
);

export const getCategory = createSelector(
  getCategoryState,
  (categoryState: CategoryState) => (categoryState && categoryState.payload)
);

export const getCategoryChildren = createSelector(
  getCategory,
  (category: Category) => (category && category.children) || []
);

export const getCategoryParents = createSelector(
  getCategory,
  (category: Category) => (category && category.parents) || []
);

export const getCategorySlug = createSelector(
  getCategory,
  (category: Category) => category && category.slug
);

export const getCategoryId = createSelector(
  getCategory,
  (category: Category) => category && category.id
);

export const isCategoryLoading = createSelector(
  getCategoryState,
  (categoryState: CategoryState) => (categoryState && categoryState.loading)
);
